import {mapActions, mapGetters, mapMutations} from 'vuex';
import Header from '../../components/header/index.vue'
import leftBar from '../../components/left-bar/index.vue'
import Table from '../../components/table/list/index.vue'
import TableOptions from '../../components/table/options/index.vue'
import warehousePopup from "@/components/popups/warehouse/index.vue";
import pagination from '@/components/pagination/index.vue'
import paginationMixin from '@/mixins/pagination/index.js'

export default {
    components:{
        Header,
        leftBar,
        Table,
        TableOptions,
        warehousePopup,
        pagination
    },
    mixins: [paginationMixin],
    data(){
        return{
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs:[
                {
                    key: 'id',
                    label: 'ID'
                },
                {
                    key: 'title',
                    labelKey: 'warehouseList.title'
                }
            ],
            items:[],
            showWarehousePopup: false,
            selectedItem: null,
        }
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide:'config/menuHide',
            warehouses:'warehouse/warehouses',
            warehouse:'warehouse/warehouse',
        })
    },
    watch:{
        warehouses(e){
            this.items = []
            e.data.map(item=>{
                this.items.push({'title': item.title, id:item.id});
            })
            this.res = e
        },
        page(e) {
            this.getWarehouses({page: e, per_page: this.per_page});
        },
        per_page(e) {
            this.getWarehouses({page: this.page, per_page: e});
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getWarehouses({page: 1, per_page: this.per_page}).then(()=>{
            this.toggleLoadingStatus(false);
        });
    },
    methods:{
        getAllItemsInTable(){
            this.selectedItem = this.items;
            this.$refs.tableComponent.getAllItemsInTable();
        },
        changePopup(item){
            this.showWarehouse(item.id)
            this.showWarehousePopup = true;
        },
        editClickWarehouse(item){
            this.showWarehouse(item.id)
            this.showWarehousePopup = true;
        },
        selectItem(item){
            if(item.length){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
        },
        sendWarehouse(form){
            this.addWarehouse(form).then(res=>{
                if(res.status){
                    this.getWarehouses();
                    this.$toasted.success(this.$t('toasts.warehouse_added'),{
                        duration : 3000
                    });
                }
                this.showWarehousePopup = false;
            })
        },
        changeWarehouse(form){
            this.editWarehouse(form).then(res=>{
                if(res.status){
                    this.getWarehouses();
                    this.$toasted.success(this.$t('toasts.warehouse_updated'),{
                        duration : 3000
                    });
                    this.showWarehousePopup = false;
                }
            })
        },
        removeItem(id){
          this.removeWarehouse(id).then(res=>{
              if(res.status){
                  this.getWarehouses();
                  this.$toasted.success(this.$t('toasts.warehouse_deleted'),{
                      duration : 3000
                  });
                  this.showWarehousePopup = false;
              }
          })
        },
        ...mapActions({
            getWarehouses:'warehouse/getWarehouses',
            addWarehouse:'warehouse/addWarehouse',
            showWarehouse:'warehouse/showWarehouse',
            editWarehouse:'warehouse/editWarehouse',
            removeWarehouse:'warehouse/removeWarehouse',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    }
}
